"use client";

import { Box } from "@chakra-ui/react";
import type { ReactNode } from "react";

/** Modal detail blocks: bordered cards on md+, divider-only stack on mobile. */
export function ModalDetailSection({
  children,
  isFirst = false,
  borderColor,
}: {
  children: ReactNode;
  isFirst?: boolean;
  borderColor: string;
}) {
  return (
    <Box
      py={{ base: 5, md: 5 }}
      px={{ base: 0, md: 5 }}
      borderRadius={{ base: 0, md: "12px" }}
      borderColor={borderColor}
      borderWidth={{ base: 0, md: "1px" }}
      borderTopWidth={{
        base: isFirst ? 0 : "1px",
        md: "1px",
      }}
    >
      {children}
    </Box>
  );
}
